import React from 'react';
import SoftTypography from '../../components/SoftTypography';
import SuiButton from '../../components/SoftButton';
import { DialogActions, Dialog, DialogTitle, DialogContent, Divider } from '@mui/material';
import { IoClose } from 'react-icons/io5';
import PropTypes from 'prop-types';
import { MdWarning } from 'react-icons/md';
import {deleteArticle} from "../../axios-client";
import {useTranslation} from "react-i18next";

function DeleteArticleDialog({
                                 isModalOpen,
                                 handleCloseModal,
                                 articleId,
                                 articleTitle,
                                 refreshArticles,
                                 setNotification
                             }) {
    const { t } = useTranslation("publicationsTranslation");
    const { i18n } = useTranslation();
    const isRTL = i18n.dir() === "rtl";
    const handleDelete = async () => {
        if (articleId) {
            try {
                const response = await deleteArticle(articleId);
                if (response.status === 200) {
                    setNotification({
                        show: true,
                        snackbarMessage: t("articleDeletedSuccessfully"),
                        severity: 'success'
                    });
                    refreshArticles();
                    handleCloseModal();
                } else if (response.status === 403) {
                    setNotification({
                        show: true,
                        snackbarMessage: t("deleteDialogUnauthorized"),
                        severity: 'error'
                    });
                } else if (response.status === 404) {
                    setNotification({
                        show: true,
                        snackbarMessage: t("deleteDialogNotFound"),
                        severity: 'error'
                    });
                } else {
                    setNotification({
                        show: true,
                        snackbarMessage:  t("deleteDialogError"),
                        severity: 'error'
                    });
                }
            } catch (error) {
                setNotification({
                    show: true,
                    snackbarMessage: t("deleteDialogGenericError"),
                    severity: 'error'
                });
            }
        }
    };
    return (
        <>
            <Dialog open={isModalOpen} aria-labelledby="form-dialog-title" maxWidth="xs" fullWidth PaperProps={{ style: { borderRadius: 15 } }}>
                <DialogTitle id="form-dialog-title" sx={{ display: 'flex', alignItems: 'center' }}>
                    {t("deleteDialogTitle")}
                    <IoClose
                        aria-label="close"
                        onClick={handleCloseModal}
                        style={{
                            position: 'absolute',
                            [isRTL ? 'left' : 'right']: 8,
                            top: 8,
                            cursor: 'pointer',
                        }}
                    />
                </DialogTitle>
                <Divider />
                <DialogContent sx={{ padding: '10px', textAlign: 'center' }}>
                    <MdWarning size={80} style={{ color: '#D32F2F' }} />

                    <SoftTypography component="div" variant="h6" style={{ marginTop: '20px', marginBottom: '10px' }}>
                        {t("deleteDialogWarning")}
                    </SoftTypography>

                    <SoftTypography component="div" variant="body2" color="secondary" style={{ fontSize: '16px' }}>
                        “{articleTitle}”
                    </SoftTypography>
                </DialogContent>
                <Divider />
                <DialogActions sx={{ gap: 1, padding: '8px 24px' }}>
                    <SuiButton variant="gradient" color="secondary"  size="medium" onClick={handleCloseModal}>
                        {t("cancel")}
                    </SuiButton>
                    <SuiButton variant="contained" color="primary" size="medium" onClick={handleDelete}>
                        {t("delete")}
                    </SuiButton>
                </DialogActions>
            </Dialog>
        </>
    );
}

DeleteArticleDialog.propTypes = {
    isModalOpen: PropTypes.bool,
    handleCloseModal: PropTypes.func,
    handleDelete: PropTypes.func,
    articleId: PropTypes.number,
    articleTitle: PropTypes.string,
    refreshArticles: PropTypes.func,
    setNotification: PropTypes.func,
};

export default DeleteArticleDialog;
